import { z } from 'zod';

import { momentFromStr } from '../../utils/datetimes/misc';
import { zodDatetime } from '../../utils/zodHelpers';
import { serviceBundleDetailsSchema, serviceBundleForListSchema } from '../api/serviceBundles';
import { addressWithLatLngSchema } from './addresses';
import {
    dayOfWeekHoursSchema,
    nameAndCodeSchema,
    patientBasicSchema,
    qhpSimpleSchema,
} from './basicSchemas';
import { serviceAreaSchema } from './misc';
import { visitForListSchema } from './visits';

const visitOrderStateSchema = nameAndCodeSchema;
export type VisitOrderState = z.infer<typeof visitOrderStateSchema>;
export const visitOrderBasic = z.object({
    uuid: z.string().uuid(),
    service_bundle: serviceBundleForListSchema,
    patient: patientBasicSchema,
});

const visitOrderOutcomeSchema = nameAndCodeSchema;
export type VisitOrderOutcome = z.infer<typeof visitOrderOutcomeSchema>;

export const visitOrderForListDisplaySchema = visitOrderBasic.extend({
    service_area: serviceAreaSchema,
    min_visits_per_unit_time: z.number().nullable(),
    max_visits_per_unit_time: z.number().nullable(),
    unit_time: z.number().nullable(),
    duration: z.number().nullable(),
    from_date: z.string().transform(momentFromStr).nullable(),
    to_date: z.string().transform(momentFromStr).nullable(),
    state: visitOrderStateSchema,
    outcome: visitOrderOutcomeSchema,
    outcome_options: z.array(visitOrderOutcomeSchema),
    created_at: zodDatetime(),
    address: addressWithLatLngSchema,
    timezone: z.string(),
});
export type VisitOrderForListDisplay = z.infer<typeof visitOrderForListDisplaySchema>;
export const visitOrderForDetailDisplaySchema = visitOrderForListDisplaySchema.extend({
    visits: z.array(visitForListSchema),
    attention_message: z.string(),
    assignable_qhps: z.array(qhpSimpleSchema),
    expected_visit_duration_minutes: z.number(),
    order_notes: z.string(),
    internal_notes: z.string(),
    day_of_week_timeslot_preferences: z.array(dayOfWeekHoursSchema),
    service_bundle_detail: serviceBundleDetailsSchema,
});
export type VisitOrderForDetailDisplay = z.infer<typeof visitOrderForDetailDisplaySchema>;
